import { render, staticRenderFns } from "./lottery-prize.vue?vue&type=template&id=7708dfa6&scoped=true&"
import script from "./lottery-prize.vue?vue&type=script&lang=ts&"
export * from "./lottery-prize.vue?vue&type=script&lang=ts&"
import style0 from "./lottery-prize.vue?vue&type=style&index=0&id=7708dfa6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7708dfa6",
  null
  
)

export default component.exports